export default "__VITE_ASSET__8znKsWwvpU$pVGiZRms5Cg__"